export default "__VITE_ASSET__Ds0MOb6___"